import { CalendarEvent } from 'mini-calendar-event-types';
import getCalendarEventByItemIdFromCache from './getCalendarEventByItemIdFromCache';
import getItemIdsByInstanceKeyFromCache from './getItemIdsByInstanceKeyFromCache';

/**
 * Attempts to find a matching event in the events cache
 * @param calendarEvent The calendar event to be located in the events cache
 */
export default function findCachedEventWithInstanceKeyOrItemId(
    calendarEvent: CalendarEvent
): CalendarEvent {
    let cachedItem: CalendarEvent = null;

    if (!calendarEvent.InstanceKey) {
        cachedItem = getCalendarEventByItemIdFromCache(calendarEvent.ItemId.Id);
    } else {
        const itemIds = getItemIdsByInstanceKeyFromCache(calendarEvent.InstanceKey);
        if (itemIds.length > 0) {
            cachedItem = getCalendarEventByItemIdFromCache(itemIds[0]);
        }
    }

    return cachedItem;
}
